

exports.__esModule = true;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

var _auth = require('xo-models/src/auth');

var _index2 = require('xo-models/src/thirdPartyWallet/index');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

var _uiRouter = require('uiRouter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoThirdPartyFlowComponent', {
    tag: 'xo-third-party-flow',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            return {
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve(),
                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {},

    lifecycle: {
        enter: function enter() {
            if (_squid.$locale.country === 'CN') {
                _squid.$locale.choose('C2', 'zh_C2', false);
            }
        },
        populate: function populate() {
            var _this = this;

            var routingDecision = function routingDecision(payload_id) {
                var thirdPartyOnboard = _index2.$ThirdPartyOnboard.instance(_this.token);

                return thirdPartyOnboard.action('lookup', {
                    data: { payload_id: payload_id },
                    success: function success(result) {

                        _logger.$logger.info('checkout_fpti', { 'is_repeat_buyer': '1' });

                        refreshAuthState().then(onAuth).then(setBaiduExperience).then(createCheckoutSession);
                    },
                    error: function error(err) {
                        _logger.$logger.error('lookup_api_error', err);
                        _logger.$logger.info('checkout_fpti', {
                            from: 'third_party_wallet_flow',
                            to: 'process_third_party_wallet_flow',
                            'int_error_description': 'baidu_lookup_failure',
                            'error_type': 'soft_decline',
                            'error_source': 'hermesnodeweb'
                        });

                        _uiRouter.$state.go('checkout.login', { baiduError: true });
                    },
                    contingencies: {
                        NO_PAYMENT_TOKEN_FOUND: function NO_PAYMENT_TOKEN_FOUND(msg, contingency) {
                            _uiRouter.$state.go('checkout.thirdPartyInfoCollectFlow', { payload_id: payload_id });
                        },
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'third_party_wallet_flow',
                                to: 'process_third_party_wallet_flow',
                                'int_error_description': 'baidu_lookup_failure',
                                'error_type': 'soft_decline',
                                'error_source': 'hermesnodeweb'
                            });
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }
                });
            };

            var createCheckoutSession = function createCheckoutSession() {
                var checkoutSessionModel = _index.$CheckoutSessionModel.instance(_this.token);

                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: _this.models.cart.supplementary && _this.models.cart.supplementary.risk_correlation_id,
                        user_selected_funding_source: {
                            product_name: 'BAIDU'
                        },
                        is_skip_gfo: true
                    },
                    success: function success() {
                        return _uiRouter.$state.go('checkout.review');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('SYMPHONY CONTINGENCY', msg);
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }

                });
            };

            var refreshAuthState = function refreshAuthState() {
                var auth = _auth.$AuthModel.instance().reload();

                _squid.$locale.choose(auth.country, auth.language, false);
                return auth;
            };

            var onAuth = function onAuth(authModel) {
                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {
                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
            };

            var setBaiduExperience = function setBaiduExperience() {
                return _thirdPartyInfo.thirdPartyExperience.setAsBaiduExperience(_this.token);
            };

            var _models = this.models,
                cart = _models.cart,
                checkoutPayee = _models.checkoutPayee;


            var hashResult = _index2.$ThirdPartyOnboard.instance(this.token).action('hash-info', {
                data: {
                    payToken: this.token
                },
                success: function success(result) {
                    return result;
                },
                contingencies: {
                    DEFAULT: function DEFAULT(msg, contingency) {
                        _uiRouter.$state.go('checkout.login', { baiduError: true });
                    }
                }
            });

            hashResult.then(function (result) {
                return _squid.$dom.loadScript('baiduComponent', 'https://www.paypalobjects.com/api/thirdPartyWallet.js').then(function () {
                    _logger.$logger.info('rendering_baidu_flow');
                    _logger.$logger.info('checkout_fpti', { to: 'rendering_baidu_iframe' });
                    return window.paypal.ThirdPartyWallet.render({
                        env: _squid.$config.thirdPartyWallet.baidu,
                        timeout: 10000,
                        properties: {
                            paypal_order_id: _this.token,

                            business_id: checkoutPayee.get('merchant.id'),

                            currency_code: cart.get('purchase.amounts.total.currency_code'),

                            transaction_amount: cart.get('purchase.amounts.total.amount'),

                            payload_hash: result.hash,

                            key_id: result.keyId
                        },

                        onComplete: function onComplete(data) {
                            _logger.$logger.info('complete_bently_flow', { payload_id: data.payloadID });
                            _logger.$logger.info('checkout_fpti', { to: 'completing_baidu_iframe' });

                            if (data && data.payloadID) {
                                return routingDecision(data.payloadID);
                            } else {

                                _uiRouter.$state.go('checkout.login', { baiduError: true });
                            }
                        },
                        onCancel: function onCancel(data) {

                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        },
                        onError: function onError(data) {
                            _logger.$logger.info('baidu_error', data);
                            _logger.$logger.info('checkout_fpti', { int_error_code: data.error_code, int_error_desc: data.error_message });
                        },
                        onTransitionStart: function onTransitionStart(data) {
                            console.log('transition start happened ', data);
                        },
                        onTransitionEnd: function onTransitionEnd(data) {
                            console.log('transition end happened ', data);
                        },
                        onTimeout: function onTimeout(data) {
                            _logger.$logger.info('baidu_flow_load_timeout');
                            _logger.$logger.info('checkout_fpti', { int_error_code: 'TIMEOUT', int_error_desc: 'Iframe timeout' });
                            _uiRouter.$state.go('checkout.login', { baiduError: true });
                        }
                    }, '#thirdPartyWalletContainer')['catch'](function (err) {
                        _logger.$logger.info('baidu_render_error', {
                            error: err.message,
                            stack: err.stack
                        });
                    });
                });
            });
        },
        exit: function exit() {}
    }

});


_squid.$Component;

_squid.$dom;

_squid.$locale;

_squid.$config;

_logger.$logger;

_index.$CheckoutPayeeModel;

_index.$CheckoutCartModel;

_index.$CheckoutAppDataModel;

_index.$CheckoutSessionModel;

_auth.$AuthModel;

_index2.$ThirdPartyOnboard;

_thirdPartyInfo.thirdPartyExperience;

_uiRouter.$state;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-third-party-wallet/directive.js
// module id = ./pages/xo-third-party-wallet/directive.js
// module chunks = 0